import { FadeUp } from "@/components/Reveal";

const SectionHeading = ({ eyebrow, title, lead, dark = false, testId }) => (
  <div className="max-w-3xl">
    {eyebrow && (
      <FadeUp>
        <p className={`eyebrow ${dark ? "text-raiz-200" : ""}`} data-testid={testId ? `${testId}-eyebrow` : undefined}>
          {eyebrow}
        </p>
      </FadeUp>
    )}
    <FadeUp delay={0.08}>
      <h2
        className={`mt-5 font-serif text-3xl sm:text-4xl lg:text-5xl font-light leading-[1.12] tracking-tight text-balance ${
          dark ? "text-raiz-50" : "text-ink"
        }`}
        data-testid={testId ? `${testId}-title` : undefined}
      >
        {title}
      </h2>
    </FadeUp>
    {lead && (
      <FadeUp delay={0.16}>
        <p className={`lead mt-6 ${dark ? "text-raiz-100/75" : ""}`}>{lead}</p>
      </FadeUp>
    )}
  </div>
);

export default SectionHeading;
